(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62474,93812,59654,55004,6050,12701,54223,59679],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 65300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paginator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/components/Paginator/utils/usePaginator.js


var usePaginator = function(param) {
    var pagesCounter = param.pagesCounter, currentPage = param.currentPage, pageSlug = param.pageSlug, className = param.className;
    var previous = "", next = "";
    var ref = (0,router.useRouter)(), _query = ref.query, category = _query.slug;
    if (currentPage > 3) previous = pagesCounter > 4 ? "start" : "";
    if (currentPage <= pagesCounter - 3) next = pagesCounter > 5 ? "next" : "";
    var pushRouter = function(currentCategory, nextPage) {
        var ref = constants/* ROUTES */.y2[pageSlug].getRoute(currentCategory, nextPage), path = ref.path, dynamicPath = ref.dynamicPath;
        window.scrollTo(0, 0);
        router_default().push({
            pathname: dynamicPath
        }, {
            pathname: path
        });
    };
    var handleOnPreviousClick = function() {
        return pushRouter(category, 1);
    };
    var handleOnPageClick = function(param) {
        var selected = param.selected;
        return pushRouter(category, selected + 1);
    };
    return {
        previous: previous,
        next: next,
        pagesCounter: pagesCounter,
        currentPage: currentPage,
        className: className,
        handleOnPageClick: handleOnPageClick,
        handleOnPreviousClick: handleOnPreviousClick
    };
};

// EXTERNAL MODULE: ./UI/components/Paginator/styles.module.scss
var styles_module = __webpack_require__(35398);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Paginator/index.jsx






var Paginator = function(props) {
    var ref = usePaginator(props), previous = ref.previous, next = ref.next, pagesCounter = ref.pagesCounter, currentPage = ref.currentPage, className = ref.className, handleOnPageClick = ref.handleOnPageClick, handleOnPreviousClick = ref.handleOnPreviousClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).paginationWrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).paginationPrev,
                onClick: handleOnPreviousClick,
                role: "button",
                tabIndex: "0",
                children: previous
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                pageCount: pagesCounter,
                pageRangeDisplayed: 4,
                marginPagesDisplayed: 0,
                nextLabel: next,
                containerClassName: (styles_module_default()).paginationContainer,
                pageClassName: (styles_module_default()).paginationItem,
                pageLinkClassName: (styles_module_default()).paginationLink,
                activeClassName: (styles_module_default()).paginationActiveClassName,
                activeLinkClassName: (styles_module_default()).paginationActiveLink,
                breakClassName: (styles_module_default()).paginationEmptyItem,
                breakLinkClassName: (styles_module_default()).paginationEmptyLink,
                previousClassName: (styles_module_default()).previousClassName,
                nextClassName: (styles_module_default()).paginationNextWrapper,
                nextLinkClassName: (styles_module_default()).paginationNext,
                disableInitialCallback: true,
                forcePage: currentPage - 1,
                onPageChange: handleOnPageClick
            })
        ]
    });
};
Paginator.defaultProps = {
    className: ""
};
Paginator.propTypes = {
    pagesCounter: (prop_types_default()).number.isRequired,
    currentPage: (prop_types_default()).number.isRequired,
    pageSlug: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_Paginator = (Paginator);


/***/ }),

/***/ 36837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./UI/components/SectionTitle/styles.module.scss
var styles_module = __webpack_require__(89494);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SectionTitle/utils/get-segment-text.js

var getSegmentText = function(text) {
    var parts = text.split(/(~~.*?~~)/g);
    return parts.map(function(part) {
        var isAlpa = /^~~.*~~$/.test(part);
        if (isAlpa) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-title-alpha": true,
                style: {
                    display: "inline"
                },
                children: part.slice(2, -2)
            }, part);
        }
        return part;
    });
};

;// CONCATENATED MODULE: ./UI/components/SectionTitle/index.jsx












var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).sectionTitleContainer, (styles_module_default())[type], className, titleStyle),
        id: title ? slugify_default()(title) : null,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-title": true,
                    isBold: true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                    mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: titleVariant,
                    className: (styles_module_default()).title,
                    children: titleSegments.length === 1 ? getSegmentText(title) : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            ket: segment,
                            "data-title": true,
                            isBold: true,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                            mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                            variant: "span",
                            className: (styles_module_default()).title,
                            children: getSegmentText(segment)
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-subtitle": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                    className: (styles_module_default()).subtitle,
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        "data-description": true,
                        size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                        className: (styles_module_default()).description,
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: secondTitleVariant,
                    className: (styles_module_default()).title,
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-subtitle": true,
                    className: (styles_module_default()).subtitle,
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-description": true,
                    className: (styles_module_default()).description,
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types_default()).string,
    titleStyle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    secondTitle: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    secondSubtitle: (prop_types_default()).string,
    description: (prop_types_default()).string,
    secondDescription: (prop_types_default()).string,
    className: (prop_types_default()).string,
    titleVariant: (prop_types_default()).string,
    secondTitleVariant: (prop_types_default()).string
};
/* harmony default export */ var components_SectionTitle = (SectionTitle);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 63111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ArticlesList; },
  "Z": function() { return /* binding */ BlogCommon_ArticlesList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./components/Common/ArticlePreview/styles.module.scss
var styles_module = __webpack_require__(25999);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/ArticlePreview/index.jsx













var ArticlePreview = function(param) {
    var slug = param.slug, title = param.title, image = param.image, tags = param.tags, introduction = param.introduction, date = param.date, type = param.type, index = param.index, isSearch = param.isSearch, handleOnCloseModalWindow = param.handleOnCloseModalWindow;
    var path = constants/* ROUTES.article.getRoute */.y2.article.getRoute(slug).path;
    var articleLinkProps = {
        path: path
    };
    if (!slug || !title || !image) {
        return null;
    }
    var handleOnArticleClick = function() {
        if (isSearch) {
            handleOnCloseModalWindow();
        }
    };
    var imageSizes = index === 0 ? {
        width: 720,
        height: 428
    } : {
        width: 297,
        height: 223
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classnames_default()((styles_module_default())[type], (0,_define_property/* default */.Z)({}, (styles_module_default()).medium, index === 0)),
        onClick: handleOnArticleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
            className: (styles_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        src: image,
                        alt: title,
                        layout: "responsive"
                    }, imageSizes), {
                        scale: 2,
                        className: (styles_module_default()).imgContainer
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).articleContent,
                    children: [
                        date && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).date,
                            children: (0,helper/* formatDate */.p6)(date)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                            className: (styles_module_default()).articlePreviewTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (styles_module_default()).title,
                                children: title
                            })
                        })),
                        introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                            className: (styles_module_default()).articlePreviewIntroduction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).introduction,
                                children: introduction
                            })
                        })),
                        (tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).tags,
                            children: (tags || []).filter(function(param) {
                                var tagSlug = param.slug;
                                return isSearch || constants/* VALUABLE_ARTICLE_CATEGORIES_SLUGS.includes */.Sk.includes(tagSlug);
                            }).map(function(param) {
                                var tagSlug = param.slug;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: routes/* routes.blog.getRoute */._.blog.getRoute(tagSlug).path,
                                    className: (styles_module_default()).tag,
                                    children: "#".concat(tagSlug.replaceAll("-", ""))
                                });
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ArticlePreview.defaultProps = {
    introduction: "",
    date: "",
    isSearch: false,
    index: 1,
    handleOnCloseModalWindow: function() {}
};
ArticlePreview.propTypes = {
    slug: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    image: (prop_types_default()).string.isRequired,
    category: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string.isRequired,
    introduction: (prop_types_default()).string,
    date: (prop_types_default()).string,
    index: (prop_types_default()).number,
    isSearch: (prop_types_default()).bool,
    handleOnCloseModalWindow: (prop_types_default()).func,
    animatioProps: prop_types_default().instanceOf(Object).isRequired
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./UI/components/Cards/BlogSubscribeCard/BlogSubscribeCard.module.scss
var BlogSubscribeCard_module = __webpack_require__(94513);
var BlogSubscribeCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogSubscribeCard_module);
;// CONCATENATED MODULE: ./UI/components/Cards/BlogSubscribeCard/index.jsx






var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var BlogSubscribeCard = function(param) {
    var toggleFullscreenSubscribe = param.toggleFullscreenSubscribe;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
        className: (BlogSubscribeCard_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: "processLaunch",
                className: (BlogSubscribeCard_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                className: (BlogSubscribeCard_module_default()).titleSection,
                title: "Subscribe",
                secondTitle: "to new posts",
                secondDescription: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                onClick: toggleFullscreenSubscribe,
                children: "Subscribe"
            })
        ]
    });
};
/* harmony default export */ var Cards_BlogSubscribeCard = (BlogSubscribeCard);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./components/BlogCommon/ArticlesList/utils/propsHelper.js




function getAnimationProps() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _index = ref.index, index = _index === void 0 ? 1 : _index, _isSearch = ref.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, _isMobileResolution = ref.isMobileResolution, isMobileResolution = _isMobileResolution === void 0 ? false : _isMobileResolution;
    var delay = isSearch ? 30 * index : 100 + 50 * index;
    var animatioProps = isSearch ? {
        type: constants/* ANIMATED_TYPE.isFade */.BK.isFade,
        delay: delay,
        duration: 200,
        distance: "1rem",
        bottom: true,
        effect: "fadeInUp"
    } : {
        type: constants/* ANIMATED_TYPE.isCustom */.BK.isCustom,
        translateY: "1.5em",
        opasityDuration: 1,
        transformDuration: 1,
        transitionDelay: delay
    };
    if (isMobileResolution) {
        animatioProps = {
            type: constants/* ANIMATED_TYPE.isCustom */.BK.isCustom,
            translateY: "0.05em",
            opasityDuration: 0.05,
            transformDuration: 0.05,
            transitionDelay: 100
        };
    }
    return animatioProps;
}
function getArticleProps() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, article = ref.article, _isSearch = ref.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, _isMobileResolution = ref.isMobileResolution, isMobileResolution = _isMobileResolution === void 0 ? false : _isMobileResolution, _index = ref.index, index = _index === void 0 ? 1 : _index;
    var previewImage = get_default()(article, "previewImageUrl.url");
    var animatioProps = getAnimationProps({
        isSearch: isSearch,
        isMobileResolution: isMobileResolution,
        index: index
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
        previewImage: previewImage,
        animatioProps: animatioProps
    });
}

// EXTERNAL MODULE: ./components/BlogCommon/ArticlesList/styles.module.scss
var ArticlesList_styles_module = __webpack_require__(99235);
var ArticlesList_styles_module_default = /*#__PURE__*/__webpack_require__.n(ArticlesList_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/ArticlesList/index.jsx










var ArticlesList = function(param) {
    var articles = param.articles, isSearch = param.isSearch, isBlogPage = param.isBlogPage, currentPage = param.currentPage, handleOnCloseModalWindow = param.handleOnCloseModalWindow, toggleFullscreenSubscribe = param.toggleFullscreenSubscribe;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var articleType = isSearch ? constants/* ARTICLE_PREVIEW_TYPES.search */.p_.search : constants/* ARTICLE_PREVIEW_TYPES.blog */.p_.blog;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ArticlesList_styles_module_default()).articlesList),
        children: articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
            var ref;
            var articleProps = getArticleProps({
                article: article,
                index: index,
                isSearch: isSearch,
                isMobileResolution: isMobileResolution
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    currentPage === 1 && isBlogPage && index === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_BlogSubscribeCard, {
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePreview, {
                        type: articleType,
                        index: index,
                        animatioProps: articleProps.animatioProps,
                        slug: articleProps.slug,
                        title: articleProps.title,
                        tags: (ref = articleProps.tagsListCollection) === null || ref === void 0 ? void 0 : ref.items,
                        introduction: articleProps.introduction,
                        image: articleProps.previewImage,
                        date: articleProps.publishedAt,
                        isSearch: isSearch,
                        handleOnCloseModalWindow: handleOnCloseModalWindow
                    }, articleProps.title)
                ]
            });
        })
    });
};
ArticlesList.defaultProps = {
    isSearch: false,
    isBlogPage: false,
    handleOnCloseModalWindow: function() {}
};
ArticlesList.propTypes = {
    articles: prop_types_default().instanceOf(Array).isRequired,
    isSearch: (prop_types_default()).bool,
    isBlogPage: (prop_types_default()).bool,
    currentPage: (prop_types_default()).number.isRequired,
    handleOnCloseModalWindow: (prop_types_default()).func,
    toggleFullscreenSubscribe: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_ArticlesList = (ArticlesList);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 94513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogSubscribeCard_card__n8ljy","image":"BlogSubscribeCard_image__al6_I","titleSection":"BlogSubscribeCard_titleSection__mbdDN"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 35398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"styles_paginationWrapper__3DhNo","paginationContainer":"styles_paginationContainer__087V2","paginationPrev":"styles_paginationPrev__bR_JQ","paginationItem":"styles_paginationItem__0UD3l","paginationNextWrapper":"styles_paginationNextWrapper__n3tXg","paginationNext":"styles_paginationNext__BVMd0","paginationActiveClassName":"styles_paginationActiveClassName__96uLh","previousClassName":"styles_previousClassName__FqecZ","paginationEmptyItem":"styles_paginationEmptyItem__NWkl9"};

/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 99235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationSubscribe":"styles_locationSubscribe__lqgd8","articlesList":"styles_articlesList__DclDg","blinking":"styles_blinking__Htl9p","swing":"styles_swing__qoiyt","animateborder":"styles_animateborder__qm_os","animateborder-overlay":"styles_animateborder-overlay__zwze2","animatecircle":"styles_animatecircle__D3mfx","animatedot":"styles_animatedot__W4oZ0","animStar":"styles_animStar__E1V34","hideText":"styles_hideText___NNWU","spin":"styles_spin__aP4Vl","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__pOhqI","outOfTransparencyMobile":"styles_outOfTransparencyMobile__JBGCL","appearance":"styles_appearance__3FmsH","appearanceFromBelow":"styles_appearanceFromBelow__CxpsV","flicker":"styles_flicker__w0Erh","vibrate1":"styles_vibrate1__dIlEp","rocket":"styles_rocket__mCgKA","burgerItem1":"styles_burgerItem1__t9_LV","burgerItem2":"styles_burgerItem2__V5aXs","burgerItem3":"styles_burgerItem3__SDZVH","burgerItem1Reverse":"styles_burgerItem1Reverse__nprsZ","burgerItem2Reverse":"styles_burgerItem2Reverse__zhzHs","burgerItem3Reverse":"styles_burgerItem3Reverse__FOc34","arrow-down":"styles_arrow-down__amOOi","image-scroll":"styles_image-scroll__fKa6G","image-scroll-reverse":"styles_image-scroll-reverse__sm2Pg","stickerbox-pointer-move":"styles_stickerbox-pointer-move__ecAd0","hide-image":"styles_hide-image__wYz6r","stickerbox-pointer-second":"styles_stickerbox-pointer-second__i6CPW","stickerbox-pointer-third":"styles_stickerbox-pointer-third__lGt4e","cedar-bounce":"styles_cedar-bounce__ivdPy"};

/***/ }),

/***/ 25999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__dAKTy","articlePreview":"styles_articlePreview__QGB75","blogCard":"styles_blogCard__N4Rwm","search":"styles_search__WoQeu","blog":"styles_blog__Oy1V7","related":"styles_related__OGlZK","articleImage":"styles_articleImage__ZaTm8","articleTitle":"styles_articleTitle__KYGJn","title":"styles_title__jzA_t","blogArticleContent":"styles_blogArticleContent__5xlVF","articlePreviewTitle":"styles_articlePreviewTitle__PDqtq","articleContent":"styles_articleContent__R_gLn","tags":"styles_tags__Mg3NQ","tag":"styles_tag__W67ll","category":"styles_category__G3Qas","date":"styles_date__X2hv_","articlePreviewIntroduction":"styles_articlePreviewIntroduction__b2G1Q","introduction":"styles_introduction__8gMO9","imgContainer":"styles_imgContainer___gHpw","medium":"styles_medium__3slxw"};

/***/ })

}]);